

<template>
  <div>
    <div class="w-100 pa-2">
      <HappeningViewerAndEditor />
    </div>
  </div>
</template>



<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
